import React, { forwardRef } from 'react';
import NumberedTable from '../ui/NumberedTable';

// Keep the table's own classes and cells in the page so specialized layouts stay intact.
const Table = forwardRef(function Table({ responsive = false, responsiveLabel = 'Scrollable table', children, ...props }, ref) {
  const content = <NumberedTable ref={ref} {...props}>{children}</NumberedTable>;

  return responsive ? (
    <div
      className="tw-w-full tw-overflow-x-auto tw-rounded-[0.75rem] tw-border-[1px] [--tw-border-opacity:1] tw-border-[rgb(226_232_240_/_var(--tw-border-opacity,_1))] [-webkit-overflow-scrolling:touch] ui-table-scroll"
      tabIndex={0}
      role="region"
      aria-label={responsiveLabel}
    >
      {content}
    </div>
  ) : content;
});

export default Table;
